import React, { useState } from 'react';
import style from "./ZoneMemberCard.module.css";
import circle from '../../../assets/img/circulogris.png';
import Options from '../../../utils/components/Options/Options';
import ModalReportPost from '../../../containers/ReportContent/ModalReportPost';
import useModal from '../../../utils/hooks/useModal';
import Button from '../../../utils/components/Button/Button';
const ZoneMemberCard = ({ member, report, expel }) => {

    let src = null
    let id = null;
    let name = null
    let lastname = null
    if (member.memberType ==="user") {
        id = member.userId._id
        name = member.userId.name
        lastname = member.userId.lastname
        src = member.userId.picture && member.userId.picture.url && member.userId.picture.url.small
    }
    if (member.memberType ==="franchise") {
        id = member.franchiseId._id
        name = member.franchiseId.socialReason
        src = member.franchiseId.picture && member.franchiseId.picture.url && member.franchiseId.picture.url.small
    }
    if (member.memberType ==="representative") {
        id = member.representativeId._id
        name = member.representativeId.userID.name
        lastname = member.representativeId.userID.lastname
        src = member.representativeId.userID.picture &&
            member.representativeId.userID.picture.url &&
            member.representativeId.userID.picture.url.small
    }
    if (member.memberType ==="warehouse") {
        id = member.warehouseId._id
        name = member.warehouseId.name
        src = member.warehouseId.profileId.picture &&
            member.warehouseId.profileId.picture.url &&
            member.warehouseId.profileId.picture.url.small
    }
   
    const [refReport, isShowReport, setIsShowReport] = useModal(false)
    const [refExpel, isShowExpel, setIsShowExpel] = useModal(false)
    return (
        <div key={id} >
            <ModalReportPost
                closeModal={() => setIsShowReport(false)}
                displayModal={isShowReport}
                communityID={member.zoneId}
                idReported={member._id}
                reportType="userChat"
            />
            <Modal
                member={member}
                displayModal={isShowExpel}
                closeModal={() => setIsShowExpel(false)}
                expel={expel}
            />
            <div className={style.zone_member_opt_container}>
                <Options style={{ position: "initial" }} type='vertical' options={[
                    {
                        text: "Reportar",
                        onClick: (e) => { setIsShowReport(true) }
                    },
                    {
                        text: "Expulsar",
                        onClick: (e) => {
                            setIsShowExpel(true)
                        }
                    }
                ]} />
            </div>

            <div className={style.zone_member_card_container}>
                <img alt="img" className="picture-image-name" onError={(e) => e.target.src = circle} src={src} />
                <div className={`first-name-image-name`}>{name}</div>
                <div className="second-name-image-name">{lastname}</div>
            </div>
        </div>

    )
};

const Modal = ({ closeModal, displayModal, member, expel }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        closeModal(e)
    }

    return <div
        className={"modal"}
        style={divStyle}
    >
        <div className="modal-content column centerContent">
            <div>

                <div className='column'>
                    <Button text='Expulsar' onClick={() => {
                        expel(member)
                    }} />
                    <Button text='Cancelar' onClick={(e) => {
                        close(e)
                    }} />
                </div>
            </div>
        </div>
    </div>
}
export default ZoneMemberCard;
